import { heroEquipment } from "../HeroEquipment";

export const piwowarzy = {
  heroes: {
    "Mistrz piwowar": {
      id: 0,
      startingEquipment: ["Sztylet", "Topór krasnoludów"],
      cost: 75,
      number: 1,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 4, 4, 2, 3, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Dowodzenie",
        "Dowódca",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Piwowar",
        "Rankor",
        "Rewelator",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 5],
    },
    "Kowal run": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: ["Błogosławieństwo Valayi","Kowal Run","Krzepki","Nieustępliwy","Odporność na magię (2)","Rankor","Rozproszenie magii (1)","Trudny do zabicia","Uporczywość","Wspinaczka","Zabobonny lęk"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Mistrz inżynier": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Mistrz inżynier",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 1, 2, 3, 5],
    },
    Zwiadowca: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 45,
      number: 2,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Zwiadowca,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Pułapkarz",
        "Ranger",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zwiadowca",
      ],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Wojownik klanowy": {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 25,
      number: 12,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    "Krasnoludzki ranger": {
      id: 5,
      startingEquipment: ["Sztylet","Topór krasnoludów"],
      cost: 45,
      number: 5,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Ranger",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zwiadowca",
      ],
    },
    "Krasnoludzki przepatrywacz": {
      id: 6,
      startingEquipment: [
        "Sztylet",
        "Topór bojowy/Nadziak",
        "Kuc",
        "Siodło & uprząż",
      ],
      cost: 80,
      number: 3,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
        Kuc: [6, 2, 0, 4, 4, 1, 2, 1, 5],
      },
      rules: [
        "Kawalerzysta",
        "Krzepki",
        "Lekka jazda",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Ranger",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zwiadowca",
      ],
    },
    "Pogromca trolli": {
      id: 7,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 3,
      equipmentList:
        heroEquipment["Kompania krasnoludzkich Piwowarów"].Pogromca,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Zaprzęg: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Kuc": [6,2,0,4,"-","-",2,1,5],
        "Kuc ": [6,2,0,4,"-","-",2,1,5]
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
    "Powóz piwny": {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Kuc: [6, 2, 0, 4, "-", "-", 2, 1, 5],
        "Kuc ": [6, 2, 0, 4, "-", "-", 2, 1, 5],
      },
      rules: [
        "Duży cel",
        "Machina wojenna",
        "Powóz piwny",
        "Rydwan",
        "Wóz Bugmana",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Kompania krasnoludzkich Piwowarów",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Reduta", "Zhańbiony"],
  mercenaries: [
    "Goniec",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ogniomistrz",
    "Poszukiwacz złota",
    "Strażnik dróg",
    "Zwiadowca",
  ],
};
